export default {
  personalDescription: [],
  profileCard: [],
  mainAnswers:[],
  descriptionUpdated: false,
  languageUpdated: false,
  randomQuestions: [],
  randomAnsweredQuestions: [],
};
